import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["extra", "toggle"]
  static values = { open: Boolean }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.hasExtraTarget) {
      this.extraTarget.classList.toggle("hidden", !this.openValue)
    }
    if (this.hasToggleTarget) {
      this.toggleTarget.textContent = this.openValue
        ? this.toggleTarget.dataset.lessLabel || "Ver menos"
        : this.toggleTarget.dataset.moreLabel || "Ver mais"
    }
  }
}
